module.exports = __webpack_public_path__ + "img/icon-team-light.cb9f72e0.svg";